/* ==========================================================================
   Ishq with Candles — theme.js
   No dependencies. Reads its settings from <script id="ishq-settings">.
   ========================================================================== */
(function () {
  'use strict';

  var S = {};
  try { S = JSON.parse(document.getElementById('ishq-settings').textContent); } catch (e) { S = {}; }
  S.routes = S.routes || {};
  S.strings = S.strings || {};
  S.dates = S.dates || {};
  S.delivery = S.delivery || {};

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem('ishq:' + k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem('ishq:' + k, v); } catch (e) {} }
  };
  var session = {
    get: function (k) { try { return JSON.parse(window.sessionStorage.getItem('ishq:' + k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem('ishq:' + k, JSON.stringify(v)); } catch (e) {} }
  };
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ishq_' + name, data || {}); } catch (e) {}
  }

  function announce(msg) {
    var r = document.getElementById('LiveRegion');
    if (r) { r.textContent = ''; setTimeout(function () { r.textContent = msg; }, 50); }
  }

  /* ---------- Money ------------------------------------------------------ */
  function formatMoney(cents, trimZeros) {
    cents = Math.round(Number(cents) || 0);
    var format = S.moneyFormat || '₹{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    function fmt(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var noDec = trimZeros && cents % 100 === 0;
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, noDec ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, noDec ? 0 : 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      default: value = fmt(cents, noDec ? 0 : 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- Dates & countdowns ---------------------------------------- */
  var pad = function (n) { return String(n).padStart(2, '0'); };
  function parts(iso) {
    var t = new Date(iso).getTime();
    if (isNaN(t)) return null;
    var ms = Math.max(0, t - Date.now());
    return { ms: ms, d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
  }
  function shortDate(d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function nextDeadline() {
    var order = ['earlybird', 'branded', 'panindia', 'express', 'diwali'];
    for (var i = 0; i < order.length; i++) {
      var d = S.dates[order[i]];
      if (d && d.iso && new Date(d.iso).getTime() > Date.now()) return d;
    }
    return null;
  }
  function initAutoCountdowns() {
    $$('[data-countdown-auto]').forEach(function (wrap) {
      var d = nextDeadline();
      var el = $('[data-countdown]', wrap);
      if (!d || !el) { wrap.hidden = true; return; }
      el.setAttribute('data-countdown', d.iso);
      var label = $('[data-cd-label]', wrap);
      if (label && d.label) label.textContent = d.label;
    });
  }
  function tickCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var iso = el.getAttribute('data-countdown');
      if (!iso) return;
      var p = parts(iso);
      if (!p) return;
      var fmt = el.getAttribute('data-format') || 'long';
      if (fmt === 'boxes') {
        var map = { d: pad(p.d), h: pad(p.h), m: pad(p.m), s: pad(p.s) };
        $$('[data-cd]', el).forEach(function (b) { b.textContent = map[b.getAttribute('data-cd')]; });
        return;
      }
      if (p.ms === 0) { el.textContent = S.strings.closed || 'Closed'; return; }
      el.textContent = fmt === 'short'
        ? p.d + 'd ' + p.h + 'h ' + p.m + 'm'
        : p.d + 'd ' + pad(p.h) + 'h ' + pad(p.m) + 'm ' + pad(p.s) + 's';
    });
  }
  function markTimelines() {
    $$('[data-timeline]').forEach(function (tl) {
      var found = false;
      $$('[data-date]', tl).forEach(function (item) {
        var t = new Date(item.getAttribute('data-date')).getTime();
        item.classList.remove('is-past', 'is-next');
        if (isNaN(t)) return;
        if (t < Date.now()) item.classList.add('is-past');
        else if (!found) { item.classList.add('is-next'); found = true; }
      });
    });
  }

  /* ---------- Pincode ---------------------------------------------------- */
  function prefixMatch(pin, list) {
    return String(list || '').split(',').some(function (p) { p = p.trim(); return p && pin.indexOf(p) === 0; });
  }
  function deliveryEstimate(pin) {
    var D = S.delivery, T = S.strings;
    if (!/^\d{6}$/.test(pin)) return { ok: false, title: T.pinInvalidTitle, text: T.pinInvalidText };
    var city = prefixMatch(pin, D.mumbaiPrefixes) ? 'Mumbai' : prefixMatch(pin, D.punePrefixes) ? 'Pune' : null;
    if (city) {
      return { ok: true, metro: true, city: city,
        title: (T.pinMetroTitle || '[city]: express delivery available').replace('[city]', city),
        text: (T.pinMetroText || '').replace('[days]', D.metroText || '') };
    }
    return { ok: true, metro: false,
      title: (T.pinIndiaTitle || '[pin]: standard delivery').replace('[pin]', pin).replace('[days]', D.indiaText || ''),
      text: (T.pinIndiaText || '').replace('[days]', D.indiaText || '') };
  }
  function initPincode() {
    var saved = store.get('pin') || '';
    $$('[data-pincode]').forEach(function (wrap) {
      var form = $('[data-pincode-form]', wrap), input = $('[data-pincode-input]', wrap), out = $('[data-pincode-result]', wrap);
      if (!form || !input || !out) return;
      if (saved) input.value = saved;
      input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); out.hidden = true; });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = deliveryEstimate(input.value);
        out.innerHTML = '';
        var t = document.createElement('strong'); t.textContent = r.title;
        var d = document.createElement('span'); d.textContent = r.text;
        out.appendChild(t); out.appendChild(d);
        out.classList.toggle('is-warn', !r.ok);
        out.hidden = false;
        if (r.ok) { store.set('pin', input.value); track('pincode_check', { metro: r.metro }); }
      });
    });
  }

  /* ---------- Hero video ------------------------------------------------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var wrap = $('[data-hero-video]', hero);
      var video = wrap && $('video', wrap);
      var btn = $('[data-hero-toggle]', hero);
      if (!video) return;
      var mobileOk = wrap.getAttribute('data-mobile') === 'true';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      video.muted = true;
      var allowed = !reducedMotion && (mobileOk || !isMobile);
      function setLabel() { if (btn) btn.textContent = video.paused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause'); }
      if (allowed) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () { setLabel(); }); }
      video.addEventListener('play', setLabel); video.addEventListener('pause', setLabel);
      setLabel();
      if (btn) btn.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    });
  }

  /* ---------- Featured collection quick filters ------------------------ */
  function initFeaturedCollections() {
    $$('[data-featured-collection]').forEach(function (sec) {
      var visible = parseInt(sec.getAttribute('data-visible'), 10) || 8;
      var suffix = sec.getAttribute('data-suffix') || '';
      var items = $$('[data-fc-item]', sec);
      var countEl = $('[data-fc-count]', sec), empty = $('[data-fc-empty]', sec);
      var state = { scent: '', budget: null };
      var scentLabel = '', budgetLabel = '';
      function apply() {
        var shown = 0, matched = 0;
        items.forEach(function (it) {
          var card = $('[data-product-card]', it);
          if (!card) return;
          var price = parseFloat(card.getAttribute('data-price')) || 0;
          var ok = (!state.scent || card.getAttribute('data-scent') === state.scent) &&
            (!state.budget || (price >= state.budget.min && price <= state.budget.max));
          if (ok) matched++;
          it.hidden = !(ok && shown < visible);
          if (ok && shown < visible) shown++;
        });
        if (countEl) countEl.textContent = matched + ' ' + suffix + (scentLabel ? ' · ' + scentLabel : '') + (budgetLabel ? ' · ' + budgetLabel : '');
        if (empty) empty.hidden = matched !== 0;
        $$('[data-fc-clear]', sec).forEach(function (b) { if (!b.closest('[data-fc-empty]')) b.hidden = !state.scent && !state.budget; });
      }
      var scentSel = $('[data-fc-scent-select]', sec), budgetSel = $('[data-fc-budget-select]', sec);
      function readSelects() {
        state.scent = scentSel ? scentSel.value : '';
        scentLabel = state.scent ? scentSel.options[scentSel.selectedIndex].text : '';
        var opt = budgetSel && budgetSel.value ? budgetSel.options[budgetSel.selectedIndex] : null;
        state.budget = opt ? { min: parseFloat(opt.getAttribute('data-min')) || 0, max: parseFloat(opt.getAttribute('data-max')) || 1e9 } : null;
        budgetLabel = opt ? opt.text : '';
        apply();
      }
      if (scentSel) scentSel.addEventListener('change', readSelects);
      if (budgetSel) budgetSel.addEventListener('change', readSelects);
      $$('[data-fc-clear]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          if (scentSel) scentSel.value = '';
          if (budgetSel) budgetSel.value = '';
          readSelects();
        });
      });
      if ((scentSel && scentSel.value) || (budgetSel && budgetSel.value)) readSelects();
    });
  }

  /* ---------- Reel modal ------------------------------------------------- */
  var modal = document.getElementById('ReelModal');
  function closeModal() {
    if (!modal || modal.hidden) return;
    var v = $('video', modal); if (v) v.pause();
    $('[data-modal-media]', modal).innerHTML = '';
    $('[data-modal-foot]', modal).innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }
  function initReels() {
    if (!modal) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-reel-open]');
      if (btn) {
        var reel = btn.closest('[data-reel]');
        var tpl = reel && $('template[data-reel-video]', reel);
        if (!tpl) return;
        $('[data-modal-media]', modal).innerHTML = '';
        $('[data-modal-media]', modal).appendChild(tpl.content.cloneNode(true));
        var foot = $('[data-reel-foot]', reel);
        $('[data-modal-foot]', modal).innerHTML = foot ? foot.innerHTML : '';
        modal.hidden = false;
        document.body.classList.add('overflow-hidden');
        var v = $('video', modal); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        $('.modal__close', modal).focus();
        track('reel_open');
        return;
      }
      if (e.target.closest('[data-modal-close]')) closeModal();
    });
  }

  /* ---------- Cart ------------------------------------------------------- */
  var drawer = document.getElementById('CartDrawer');
  var isCartPage = !!$('[data-cart-page]');
  var lastFocus = null;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || S.strings.cartError); err.data = j; throw err; } return j; });
    });
  }
  function sectionsParam() { return drawer ? { sections: 'cart-drawer', sections_url: window.location.pathname } : {}; }
  function renderDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-drawer-inner]');
    var cur = $('[data-drawer-inner]', drawer);
    if (!fresh || !cur) return;
    var scroll = ($('.drawer__body', cur) || {}).scrollTop || 0;
    cur.innerHTML = fresh.innerHTML;
    cur.setAttribute('data-count', fresh.getAttribute('data-count'));
    var body = $('.drawer__body', cur); if (body) body.scrollTop = scroll;
    setCount(fresh.getAttribute('data-count'));
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function refreshCount() {
    fetch((S.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  function openDrawer() {
    if (!drawer) { window.location.href = S.routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setTimeout(function () { var p = $('.drawer__panel', drawer); if (p) p.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function afterChange(res, open) {
    if (isCartPage) { window.location.reload(); return; }
    if (res && res.sections && res.sections['cart-drawer']) renderDrawer(res.sections['cart-drawer']);
    else refreshCount();
    if (open) openDrawer();
  }
  function addItems(items, opts) {
    opts = opts || {};
    var body = Object.assign({ items: items }, sectionsParam());
    return postJSON(S.routes.cartAdd + '.js', body).then(function (res) {
      track('add_to_cart', { items: items.length });
      announce(S.strings.added || 'Added to cart');
      if (opts.checkout) { window.location.href = '/checkout'; return res; }
      if (S.cartType === 'page' || !drawer) { window.location.href = S.routes.cart || '/cart'; return res; }
      afterChange(res, true);
      return res;
    });
  }
  function changeLine(key, qty) {
    var body = Object.assign({ id: key, quantity: qty }, sectionsParam());
    return postJSON(S.routes.cartChange + '.js', body).then(function (res) { afterChange(res, false); })
      .catch(function (err) { alert(err.message); });
  }
  var attrTimer = null;
  function updateAttributes(attrs) {
    return postJSON(S.routes.cartUpdate + '.js', { attributes: attrs }).catch(function () {});
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && drawer && S.cartType !== 'page') { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var line = step.closest('[data-line-key]');
        if (line) {
          var input = $('[data-line-qty]', line);
          var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
          input.value = q;
          line.style.opacity = '.6';
          changeLine(line.getAttribute('data-line-key'), q);
        }
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) { var l = rm.closest('[data-line-key]'); l.style.opacity = '.6'; changeLine(l.getAttribute('data-line-key'), 0); return; }

      var upAdd = e.target.closest('[data-upsell-add]');
      if (upAdd) { upAdd.classList.add('is-loading'); addItems([{ id: Number(upAdd.getAttribute('data-upsell-add')), quantity: 1 }]).catch(function (err) { alert(err.message); }); return; }
      var upRm = e.target.closest('[data-upsell-remove]');
      if (upRm) { upRm.classList.add('is-loading'); changeLine(upRm.getAttribute('data-upsell-remove'), 0); return; }
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-line-qty]')) {
        var line = t.closest('[data-line-key]');
        changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(t.value, 10) || 0));
      } else if (t.matches('[data-gift-wrap]')) {
        if (t.checked) addItems([{ id: Number(t.getAttribute('data-gift-wrap')), quantity: 1 }]).catch(function (err) { alert(err.message); });
        else if (t.getAttribute('data-line')) changeLine(t.getAttribute('data-line'), 0);
      } else if (t.matches('[data-cart-attribute-check]')) {
        var a = {}; a[t.getAttribute('data-cart-attribute-check')] = t.checked ? 'Yes' : '';
        updateAttributes(a);
      }
    });
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-cart-attribute]')) {
        clearTimeout(attrTimer);
        attrTimer = setTimeout(function () { var a = {}; a[t.getAttribute('data-cart-attribute')] = t.value; updateAttributes(a); }, 500);
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-quick-add]');
      if (!form) return;
      e.preventDefault();
      var btn = $('[type="submit"]', form); if (btn) btn.classList.add('is-loading');
      var id = Number(form.querySelector('[name="id"]').value);
      var qty = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
      addItems([{ id: id, quantity: qty }])
        .catch(function (err) { alert(err.message); })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Product page ---------------------------------------------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-product-form]', section) || $('form[action*="/cart/add"]', section);
    if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form), addLabel = $('[data-add-label]', form);
    var buyBtn = $('[data-buy-now]', form);
    var qtyInput = $('[data-pdp-qty-input]', form);
    var errEl = $('[data-pdp-error]', form);
    var fieldsets = $$('[data-option-index]', form);
    var current = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];

    function selected() {
      return fieldsets.map(function (fs) {
        var sel = $('[data-option-select]', fs);
        if (sel) return sel.value;
        var on = $('.is-active[data-value]', fs);
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function addonSum() {
      return $$('[data-addon]', form).reduce(function (t, c) { return t + (c.checked ? Number(c.getAttribute('data-addon-price')) : 0); }, 0);
    }
    function qty() { return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1); }
    function updatePrices() {
      if (!current) return;
      var unit = current.price + addonSum();
      var unitEl = $('[data-pdp-unit]', section); if (unitEl) unitEl.textContent = formatMoney(unit, true);
      var totalEl = $('[data-pdp-total]', section); if (totalEl) totalEl.textContent = formatMoney(unit * qty(), true);
      var sticky = $('[data-sticky-price]'); if (sticky) sticky.textContent = formatMoney(unit, true);
      var s = $('[data-pdp-price] s', section);
      if (s) { if (current.compare_at_price > current.price) { s.hidden = false; s.textContent = formatMoney(current.compare_at_price, true); } else s.hidden = true; }
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        $$('[data-value]', fs).forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var test = opts.slice(); test[i] = val;
          var avail = data.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return test[k] == null || o === test[k]; }); });
          btn.classList.toggle('is-unavailable', !avail);
        });
      });
    }
    function updateBadge(opts) {
      var badge = $('[data-pdp-badge]', section);
      if (!badge || data.badgeOptionIndex < 0) return;
      var fs = fieldsets[data.badgeOptionIndex];
      var on = fs && $('.is-active[data-value]', fs);
      if (!on) { badge.hidden = true; return; }
      $('[data-pdp-badge-color]', badge).style.background = on.getAttribute('data-hex') || '';
      $('[data-pdp-badge-text]', badge).textContent = opts[data.badgeOptionIndex];
      badge.hidden = false;
      var cur = $('[data-option-current]', fs); if (cur) cur.textContent = opts[data.badgeOptionIndex];
      var jar = $('[data-pdp-jar]', section); if (jar) jar.textContent = opts[data.badgeOptionIndex];
    }
    function showMedia(id) {
      if (!id) return;
      var slide = $('.pdp__slide[data-media-id="' + id + '"]', section);
      if (!slide) return;
      $$('.pdp__slide', section).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    }
    function updateStock() {
      var box = $('[data-pdp-stock]', section);
      if (!box || !current) return;
      var th = Number(box.getAttribute('data-threshold')) || 20, batch = Number(box.getAttribute('data-batch')) || 60;
      var show = current.tracked && current.qty > 0 && current.qty <= th;
      box.hidden = !show;
      if (show) {
        $('[data-pdp-stock-count]', box).textContent = current.qty;
        $('[data-pdp-stock-fill]', box).style.width = Math.min(100, Math.round(current.qty / batch * 100)) + '%';
      }
    }
    function onVariantChange() {
      var opts = selected();
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      markAvailability(opts);
      updateBadge(opts);
      current = v || null;
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = S.strings.unavailable || 'Unavailable';
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      if (buyBtn) buyBtn.disabled = !v.available;
      addLabel.textContent = v.available ? (S.strings.addToCart || 'Add to cart') : (S.strings.soldOut || 'Sold out');
      var stickyBtn = $('[data-sticky-add]'); if (stickyBtn) stickyBtn.disabled = !v.available;
      updatePrices();
      updateStock();
      if (v.media_id) showMedia(v.media_id);
      var burnRow = $('[data-pdp-burn-row]', section);
      if (burnRow) { burnRow.hidden = !v.burn; $('[data-pdp-burn]', burnRow).textContent = v.burn || ''; }
      try {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    fieldsets.forEach(function (fs) {
      var sel = $('[data-option-select]', fs);
      if (sel) sel.addEventListener('change', onVariantChange);
      $$('[data-value]', fs).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-value]', fs).forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
          onVariantChange();
        });
      });
    });
    $$('[data-addon]', form).forEach(function (c) { c.addEventListener('change', updatePrices); });
    $$('[data-pdp-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() + parseInt(b.getAttribute('data-pdp-qty'), 10)); updatePrices(); });
    });
    if (qtyInput) qtyInput.addEventListener('change', updatePrices);
    $$('[data-thumb]', section).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    function items() {
      var q = qty();
      var list = [{ id: Number(idInput.value), quantity: q }];
      $$('[data-addon]', form).forEach(function (c) { if (c.checked) list.push({ id: Number(c.getAttribute('data-addon')), quantity: q, properties: { _for: data.title } }); });
      return list;
    }
    function submit(checkout) {
      if (!current || !current.available) return;
      if (errEl) errEl.hidden = true;
      addBtn.classList.add('is-loading');
      addItems(items(), { checkout: checkout })
        .catch(function (err) { if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } })
        .then(function () { addBtn.classList.remove('is-loading'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });
    if (buyBtn) buyBtn.addEventListener('click', function () { submit(true); });

    var sticky = $('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      var stickyAdd = $('[data-sticky-add]', sticky);
      stickyAdd.addEventListener('click', function () { submit(false); });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-bar', show);
      }).observe(addBtn);
    }

    // Delivery estimate by pincode
    var pinInput = $('[data-pdp-pin]', section), pinText = $('[data-pdp-delivery-text]', section);
    function pdpPin() {
      var pin = pinInput.value.replace(/\D/g, '').slice(0, 6);
      pinInput.value = pin;
      if (!/^\d{6}$/.test(pin)) { pinText.textContent = S.strings.enterPin; return; }
      store.set('pin', pin);
      var metro = prefixMatch(pin, S.delivery.mumbaiPrefixes) || prefixMatch(pin, S.delivery.punePrefixes);
      var days = metro ? Number(S.delivery.metroDays || 2) : Number(S.delivery.indiaDays || 5);
      var d = new Date(Date.now() + days * 864e5);
      pinText.textContent = (S.strings.arrivesBy || 'Arrives by [date] to').replace('[date]', shortDate(d));
    }
    if (pinInput && pinText) {
      var saved = store.get('pin'); if (saved) pinInput.value = saved;
      pinInput.addEventListener('input', pdpPin);
      pdpPin();
    }
    updatePrices();
    if (fieldsets.length) markAvailability(selected());
    updateBadge(selected());
  }

  /* ---------- Menu drawer (phones and tablets) -------------------------- */
  function initMenu() {
    $$('[data-menu-drawer]').forEach(function (d) {
      if (d.dataset.ready) return; d.dataset.ready = '1';
      var panel = $('.menu-drawer__panel', d);
      var toggles = $$('[data-menu-open]');
      var back = null;
      function open() {
        back = document.activeElement;
        d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
        document.body.classList.add('overflow-hidden');
        setTimeout(function () { if (panel) panel.focus(); }, 60);
      }
      function close() {
        if (!d.classList.contains('is-open')) return;
        d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        document.body.classList.remove('overflow-hidden');
        if (back && back.focus) back.focus();
      }
      toggles.forEach(function (t) { t.addEventListener('click', open); });
      $$('[data-menu-close]', d).forEach(function (b) { b.addEventListener('click', close); });
      $$('a', d).forEach(function (a) { a.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var mq = window.matchMedia('(min-width: 990px)');
      if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) close(); });
    });
  }

  /* ---------- Collection facets ----------------------------------------- */
  function initFacets() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-facet-input]')) { var f = e.target.closest('form'); if (f) f.submit(); }
      if (e.target.matches('[data-sort-select]')) {
        var formId = e.target.getAttribute('form');
        if (formId && document.getElementById(formId)) { document.getElementById(formId).querySelector('[name="sort_by"]').value = e.target.value; document.getElementById(formId).submit(); }
        else { var url = new URL(window.location.href); url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page'); window.location.href = url.toString(); }
      }
    });
    $$('[data-facets-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facets = $('[data-facets-form]');
        if (!facets) return;
        var open = facets.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });
  }

  /* ---------- Help tabs --------------------------------------------------- */
  function initHelpTabs() {
    var tabsWrap = $('[data-help-tabs]');
    var panels = $$('.help-panel[data-panel]');
    if (!tabsWrap || !panels.length) { panels.forEach(function (p) { p.classList.add('is-active'); }); return; }
    var title = $('[data-help-title]', tabsWrap);
    var defaultTitle = title ? title.textContent : '';
    var tabs = $$('[data-help-tab]', tabsWrap);
    function activate(id, scroll) {
      var panel = panels.filter(function (p) { return p.getAttribute('data-panel') === id; })[0];
      if (!panel) { panel = panels[0]; id = panel.getAttribute('data-panel'); }
      panels.forEach(function (p) { p.classList.toggle('is-active', p === panel); });
      tabs.forEach(function (t) { var on = t.getAttribute('data-help-tab') === id; t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false'); });
      if (title) title.textContent = panel.getAttribute('data-panel-title') || defaultTitle;
      if (scroll) tabsWrap.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var id = t.getAttribute('data-help-tab');
        try { window.history.replaceState({}, '', '#' + id); } catch (err) {}
        activate(id, false);
      });
    });
    window.addEventListener('hashchange', function () { activate(window.location.hash.slice(1), true); });
    activate(window.location.hash.slice(1) || (tabs[0] && tabs[0].getAttribute('data-help-tab')), false);
    document.addEventListener('shopify:section:select', function (e) {
      var p = e.target.querySelector('.help-panel[data-panel]');
      if (p) activate(p.getAttribute('data-panel'), false);
    });
  }

  /* ---------- Forms ------------------------------------------------------ */
  function validate(form) {
    var firstBad = null;
    $$('[data-required], [data-validate], [data-minlength]', form).forEach(function (input) {
      var err = input.parentElement.querySelector('.field__error');
      var v = (input.value || '').trim(), msg = '';
      if (input.hasAttribute('required') && !v) msg = input.getAttribute('data-required');
      else if (input.getAttribute('data-validate') === 'email' && v && !/^\S+@\S+\.\S+$/.test(v)) msg = input.getAttribute('data-required');
      else if (input.getAttribute('data-validate') === 'phone' && v.replace(/\D/g, '').length < 10) msg = input.getAttribute('data-required');
      else if (input.getAttribute('data-minlength') && v.length < Number(input.getAttribute('data-minlength'))) msg = input.getAttribute('data-required');
      input.classList.toggle('is-invalid', !!msg);
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (err) err.textContent = msg || '';
      if (msg && !firstBad) firstBad = input;
    });
    if (firstBad) firstBad.focus();
    return !firstBad;
  }
  function fillTemplate(el, values) {
    if (!el) return;
    var t = el.getAttribute('data-template') || '';
    Object.keys(values).forEach(function (k) { t = t.split('[' + k + ']').join(values[k] || ''); });
    el.textContent = t.replace(/\s+,/g, ',').replace(/,\s*\./g, '.').replace(/\s{2,}/g, ' ');
  }
  function initForms() {
    $$('[data-quote-form] form, form[data-quote-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!validate(form)) { e.preventDefault(); return; }
        session.set('quote', {
          name: (form.querySelector('[name="contact[name]"]') || {}).value,
          qty: (form.querySelector('[name="contact[Number of gifts]"]') || {}).value,
          email: (form.querySelector('[name="contact[email]"]') || {}).value
        });
        track('quote_submit');
      });
    });
    $$('form[data-contact-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!validate(form)) { e.preventDefault(); return; }
        session.set('contact', {
          name: (form.querySelector('[name="contact[name]"]') || {}).value,
          email: (form.querySelector('[name="contact[email]"]') || {}).value
        });
        track('contact_submit');
      });
      var topic = $('[data-topic-select]', form), orderField = $('[data-order-field]', form);
      if (topic && orderField) {
        var list = (topic.getAttribute('data-order-topics') || '').split(',').map(function (s) { return s.trim(); });
        topic.addEventListener('change', function () { orderField.hidden = list.indexOf(topic.value.toLowerCase()) === -1; });
      }
    });
    var qs = $('[data-quote-success]');
    if (qs) {
      var q = session.get('quote') || {};
      fillTemplate($('[data-quote-thanks]', qs), q);
      fillTemplate($('[data-quote-thanks-text]', qs), q);
      setTimeout(function () { qs.scrollIntoView({ block: 'center' }); qs.focus(); }, 100);
    }
    var cs = $('[data-contact-success]');
    if (cs) {
      var c = session.get('contact') || {};
      fillTemplate($('[data-contact-thanks]', cs), c);
      fillTemplate($('[data-contact-thanks-text]', cs), c);
      setTimeout(function () { cs.scrollIntoView({ block: 'center' }); cs.focus(); }, 100);
    }

    // Quote prefill + smooth scroll
    document.addEventListener('click', function (e) {
      var pre = e.target.closest('[data-quote-prefill]');
      if (pre) {
        var budget = document.getElementById('Quote-budget');
        var b = pre.getAttribute('data-budget');
        if (budget && b && Array.prototype.some.call(budget.options, function (o) { return o.value === b; })) budget.value = b;
        var notes = document.getElementById('Quote-notes');
        if (notes && !notes.value) notes.value = pre.getAttribute('data-note') || '';
      }
      var link = e.target.closest('[data-scroll-to], [data-quote-prefill]');
      if (link) {
        var target = document.querySelector(link.getAttribute('data-scroll-to') || '#quote');
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
          var first = target.querySelector('input:not([type=hidden]), select, textarea');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
        }
      }
      var ev = e.target.closest('[data-event]');
      if (ev) track(ev.getAttribute('data-event'));
    });

    // WhatsApp opt-in
    $$('[data-wa-optin]').forEach(function (form) {
      var wrap = form.closest('[data-optin]');
      var input = $('[data-wa-number]', form), err = wrap && $('[data-wa-error]', wrap), ok = wrap && $('[data-wa-success]', wrap);
      input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 10); if (err) err.textContent = ''; });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (input.value.length !== 10) { if (err) err.textContent = (S.strings.waError || 'Enter a 10-digit mobile number'); return; }
        var msg = (form.getAttribute('data-message') || '').replace('[number]', input.value);
        window.open('https://wa.me/' + (S.whatsapp || '') + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
        form.hidden = true; if (ok) ok.hidden = false;
        track('whatsapp_optin');
      });
    });

    // Track order
    $$('[data-track-form]').forEach(function (form) {
      var sec = form.closest('section') || document;
      var no = $('[data-track-no]', form), ph = $('[data-track-phone]', form), err = $('[data-track-error]', form);
      var res = $('[data-track-result]', sec);
      ph.addEventListener('input', function () { ph.value = ph.value.replace(/\D/g, '').slice(0, 10); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var order = no.value.trim().replace(/^#/, ''), phone = ph.value;
        if (order.length < 3) { err.textContent = S.strings.trackNoError || 'Enter your order number from the confirmation message.'; return; }
        if (phone.length !== 10) { err.textContent = S.strings.trackPhoneError || 'Enter the 10-digit phone number used at checkout.'; return; }
        err.textContent = '';
        var url = form.getAttribute('data-url');
        if (url) { window.open(url.replace('[order]', encodeURIComponent(order)).replace('[phone]', encodeURIComponent(phone)), '_blank', 'noopener'); track('track_order'); return; }
        var wa = (form.getAttribute('data-wa') || '').split('%5Border%5D').join(encodeURIComponent('#' + order)).split('%5Bphone%5D').join(encodeURIComponent(phone));
        if (res) {
          $('[data-track-title]', res).textContent = (S.strings.trackTitle || 'Order [order]').replace('[order]', '#' + order);
          $('[data-track-text]', res).textContent = S.strings.trackText || '';
          var a = $('[data-track-link]', res); a.href = wa; a.textContent = S.strings.trackButton || 'Get tracking on WhatsApp';
          res.hidden = false;
          var side = $('[data-track-side]', sec); if (side) side.hidden = true;
        }
        track('track_order');
      });
    });

    // Login / recover toggle
    var recover = $('[data-recover]'), login = $('[data-login]');
    function showRecover(on) { if (recover && login) { recover.hidden = !on; login.hidden = on; } }
    $$('[data-recover-toggle]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); showRecover(recover.hidden); }); });
    if (window.location.hash === '#recover') showRecover(true);
  }

  /* ---------- Recommendations ------------------------------------------ */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.hidden = true;
      }).catch(function () { el.hidden = true; });
    });
  }

  /* ---------- Boot -------------------------------------------------------- */
  function boot() {
    initAutoCountdowns();
    tickCountdowns();
    markTimelines();
    setInterval(tickCountdowns, 1000);
    setInterval(markTimelines, 60000);
    initMenu();
    initPincode();
    initHero();
    initFeaturedCollections();
    initReels();
    initCart();
    $$('[data-product-section]').forEach(initProduct);
    initFacets();
    initHelpTabs();
    initForms();
    initRecommendations();
    if ($('[data-sticky-bar]')) document.body.classList.add('has-sticky-bar');
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeModal(); } });
    document.addEventListener('shopify:section:load', function () {
      initAutoCountdowns(); tickCountdowns(); markTimelines(); initMenu(); initPincode(); initHero(); initFeaturedCollections();
      $$('[data-product-section]').forEach(initProduct); initHelpTabs();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
